import * as Bixby from '$/core';

export abstract class UserActivityService {
  public static baseUrl = Bixby.Constants.API_USERACTIVITYCONTROLLER;

  public static async getByClientForCompliance(
    skip: number,
    take: number,
    filters?: Bixby.Models.UserActivityFilter[]
  ): Promise<Bixby.Models.PaginatedSearchResult<Bixby.Models.UserActivity>> {
    const pagination: Bixby.Models.PaginatedSearchRequest = { skip, take, filters };
    const route = Bixby.API.ServerRoute.forAction(`${UserActivityService.baseUrl}/${Bixby.Constants.API_ACTION_PORTAL}`);
    return await Bixby.API.post(route, pagination);
  }

  public static async downloadGrid(filters: Bixby.Models.UserActivityFilter[]) {
    const url = `${UserActivityService.baseUrl}/${Bixby.Constants.API_ACTION_DOWNLOAD}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.postFileWithMetadata(route, { filters });
  }
}
